import { render, staticRenderFns } from "./LandingPagePostcodeSearch.vue?vue&type=template&id=956c14e8&scoped=true&"
import script from "./LandingPagePostcodeSearch.vue?vue&type=script&lang=js&"
export * from "./LandingPagePostcodeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c14e8",
  null
  
)

export default component.exports